import { Avatar, AvatarProps } from '@optiro/ui';

interface CompanyLogoProps extends Omit<AvatarProps, 'src' | 'name' | 'radius'> {
  logoUrl: string | null | undefined;
  name: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const isFallbackUrl = (url: string) => url.includes('fallback');

/** Square avatar for a company logo — same fallback-to-initials trick as AccountAvatar. */
const CompanyLogo = ({ logoUrl, name, ...props }: CompanyLogoProps) => {
  const src = logoUrl && !isFallbackUrl(logoUrl) ? logoUrl : null;

  return <Avatar src={src} name={name} color="initials" radius="sm" {...props} />;
};

export { CompanyLogo };
